/* wdd-custom.js — vlastní vrstva Whoop·de·doo, nepřepisovat při update šablony */

(() => {
  const stabilizeHomePageSlider = () => {
    const startedAt = Date.now();

    const applyStabilization = () => {
      const slider = document.querySelector('.home_page_slider .slider-demo');
      const swiper = slider?.swiper;

      if (!slider || !swiper?.mousewheel) {
        if (Date.now() - startedAt < 2000) {
          window.requestAnimationFrame(applyStabilization);
        }

        return;
      }

      if (slider.dataset.wddMousewheelStabilized === 'true') return;
      slider.dataset.wddMousewheelStabilized = 'true';

      if (swiper.params?.mousewheel) {
        swiper.params.mousewheel.thresholdDelta = 50;
        swiper.params.mousewheel.thresholdTime = 350;
      }

      swiper.mousewheel.disable();

      window.setTimeout(() => {
        if (!swiper.destroyed && swiper.mousewheel) {
          swiper.mousewheel.enable();
        }
      }, 1200);
    };

    applyStabilization();
  };

  const refreshCachedLocalizedHeader = () => {
    const isCzech = document.documentElement.lang?.toLowerCase().startsWith('cs')
      || window.location.pathname.startsWith('/cs');

    if (!isCzech) return;

    const headerSection = document.getElementById('shopify-section-header');
    if (!headerSection) return;

    const cachedShopDropdown = headerSection.querySelector(
      ".header__inline-menu .list-menu-item.list-menu--submenu a[aria-label='Obchod'][href*='/collections/all']"
    );

    if (!cachedShopDropdown) return;

    const sectionUrl = new URL(window.location.href);
    sectionUrl.searchParams.set('sections', 'header');
    sectionUrl.searchParams.set('wdd_header_refresh', '1');

    fetch(`${sectionUrl.pathname}${sectionUrl.search}`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Header refresh failed');
        return response.json();
      })
      .then((sections) => {
        if (!sections?.header) return;

        const template = document.createElement('template');
        template.innerHTML = sections.header.trim();
        const freshHeaderSection = template.content.querySelector('#shopify-section-header');
        if (!freshHeaderSection) return;

        headerSection.replaceWith(freshHeaderSection);

        const headerHeight = freshHeaderSection.getBoundingClientRect().height;
        if (headerHeight) {
          document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        }
      })
      .catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      stabilizeHomePageSlider();
      refreshCachedLocalizedHeader();
    }, { once: true });
  } else {
    stabilizeHomePageSlider();
    refreshCachedLocalizedHeader();
  }

  document.addEventListener('shopify:section:load', stabilizeHomePageSlider);
})();
